import BaseOnboardingService from "./baseOnboarding.service";

class UnavailabilityPlaceService extends BaseOnboardingService {
  constructor() {
    super("unavailability-place");
  }
}

export default new UnavailabilityPlaceService();